import { render, staticRenderFns } from "./Swiper1.vue?vue&type=template&id=5277352b&scoped=true"
import script from "./Swiper1.vue?vue&type=script&lang=js"
export * from "./Swiper1.vue?vue&type=script&lang=js"
import style0 from "./Swiper1.vue?vue&type=style&index=0&id=5277352b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277352b",
  null
  
)

export default component.exports